let development_token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJndWVzcy1hZG1pbi5tYWl5dWFuLm9ubGluZSIsImF1ZCI6Imd1ZXNzLWFkbWluLm1haXl1YW4ub25saW5lIiwiaWF0IjoxNjk5NjcwNjcwLCJuYmYiOjE2OTk2NzA2NzAsImV4cCI6MTczMTI5MzA3MCwianRpIjp7ImlkIjo1LCJ0eXBlIjoiYXBpIn19.13Vy4erP5UYRJL9o9mLN27uUM9rWIXuX3uSepRoxQF4';

export const setToken = (token) => {
	localStorage.setItem('token', token)
}


export const getToken = () => {
	const token = process.env.NODE_ENV == 'development' ? development_token : localStorage.getItem('token')
	if (token) {
		return token
	} else {
		return false
	}
}